<div class="card"
     [class]="class"
     [class.acc-card-border]="border"
     [class.card-sm]="size === 'sm'">
  <ng-content></ng-content>
</div>
